/**
 * catalog - каталог
 */

export const catalog = {
    namespaced: true,

    state: () => ({
        currentPage: null,
        lastPage: null,
    }),

    mutations: {
        setCurrentPage: (state, payload) => {
            state.currentPage = payload;
        },
        
        setLastPage: (state, payload) => {
            state.lastPage = payload;
        },
    },

    actions: {        
        setCurrentPage: ({ dispatch, commit }, payload) => {
            commit('setCurrentPage', payload);
        },

        setLastPage: ({ dispatch, commit }, payload) => {
            commit('setLastPage', payload);
        },
    },

    getters: {        
        lastPage: state => {
            return state.lastPage;
        },

        currentPage: state => {
            return state.currentPage;
        },
    }
}